var $33fab8219207655a$exports = {};
$33fab8219207655a$exports = {
  "calendar": "\u65E5\u66C6",
  "day": "\u65E5",
  "dayPeriod": "\u4E0A\u5348/\u4E0B\u5348",
  "endDate": "\u7D50\u675F\u65E5\u671F",
  "era": "\u7EAA\u5143",
  "hour": "\u5C0F\u65F6",
  "minute": "\u5206\u949F",
  "month": "\u6708",
  "second": "\u79D2",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.startDate, " \u81F3 ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "\u9078\u5B9A\u7684\u6642\u9593\uFF1A".concat(args.time);
  },
  "startDate": "\u958B\u59CB\u65E5\u671F",
  "timeZoneName": "\u65F6\u533A",
  "weekday": "\u5DE5\u4F5C\u65E5",
  "year": "\u5E74"
};
export { $33fab8219207655a$exports as default };